import React, { memo } from 'react';
import PropTypes from 'prop-types';

export const PollenGauge = memo(({pollenIndex}) => {
    const size = 70;
    const centerCoordinate = size / 2;
    const dialWidth = 3;
    const radius = (size - (2 * dialWidth)) / 2;
    const circumference = 2 * Math.PI * radius;
    const defaultColor = 'rgba(0,0,0,.075)';
    const pollenValueArc = (circumference * (1 - (pollenIndex / 14)));

    return (
        <svg
            height={size}
            width={size}
            viewBox={`0 0 ${size} ${size}`} >
            <g transform={`rotate(-90 ${centerCoordinate} ${centerCoordinate})`} >
                <circle
                    cx={centerCoordinate}
                    cy={centerCoordinate}
                    r={radius}
                    fill='none'
                    stroke={defaultColor}
                    strokeWidth={dialWidth} />
                <circle
                    cx={centerCoordinate}
                    cy={centerCoordinate}
                    r={radius}
                    fill='none'
                    stroke='#ffffff'
                    strokeWidth={dialWidth}
                    strokeDasharray={circumference}
                    strokeDashoffset={pollenValueArc}
                    strokeLinecap='round' />
                <text transform={`rotate(90 ${centerCoordinate} ${centerCoordinate})`}
                    fontSize='15'
                    stroke="#ffffff"
                    fill='#ffffff'
                    textAnchor="middle"
                    alignmentBaseline="central"
                    x={centerCoordinate}
                    y={centerCoordinate}>
                    {pollenIndex}
                </text>
            </g>
        </svg>
    );
});

PollenGauge.displayName = 'PollenGauge';
PollenGauge.propTypes = {
    pollenIndex: PropTypes.number
};

